import Loader from '@components/Loader'
import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'
import SwipeableDrawer from '@mui/material/SwipeableDrawer'
import React from 'react'
import VariantKitForm from './VariantKitForm'
import { useTranslation } from 'react-i18next'

export interface ISupplyDataVariant {
  id: number
  supplyProductPk: number
  supplyVariantPk: number
  supplyVariantName: string
  variantName: string
  availability: boolean
  price: { currency: string; gross: string; net: string } | null
  priceUndiscounted: { currency: string; gross: string; net: string } | null
  isShippingRequired: boolean
  isInCart: boolean
  isSupply: boolean
  cartQuantity: number
  stockQty: number
  outOfStockStatus: string
  wholesalePrice: { currency: string; gross: string; net: string }
  attributes: { [key: string]: string }
  cartLine: number | null
}

export interface ISupplyDataProduct {
  id: number
  specificsName: string
  specificsPk: number
  specificsSlug: string
  imageURL: string
  isShippingRequired: boolean
  outOfStockStatus: string
  priceRange: { min: number; max: number }
  cartLine: number | null
  currency: string
}

export interface ISupplyFormData {
  cartLinePk: number | null
  setAsDefault: boolean
  supplyData: {
    supplyProduct: ISupplyDataProduct
    variants: ISupplyDataVariant[]
  }[]
}

interface IProps {
  isOpen: boolean
  data: ISupplyFormData | null
  loading: boolean
  isWholesale?: boolean

  onOpen(): void

  onClosePanel(): void

  onSubmit(
    supplyLine: number | null,
    variants: { pk: number; quantity: number }[],
    setAsDefault: boolean
  ): Promise<void>
}

const VariantKitPanel: React.FC<IProps> = ({ isOpen, onOpen, onClosePanel, data, onSubmit, loading, isWholesale }) => {
  const { t } = useTranslation()
  // No wrapper element: the drawer renders in a portal, and an empty wrapper would take a gap in flex layouts
  // (e.g. the product card panel).
  return (
    <>
      <SwipeableDrawer
        className='variant-kit__panel'
        anchor='right'
        open={isOpen}
        onOpen={onOpen}
        onClose={onClosePanel}
        disableSwipeToOpen
      >
        <div className='flex flex-col h-full'>
          <div className='flex items-center justify-between px-20 py-20 border-0 border-b border-solid border-gray-400'>
            <span className='text-xl font-semibold text-left'>{t('title.buildYourKit', 'Build your kit')}</span>
            <IconButton onClick={onClosePanel} size='medium' title={t('close', 'Close')}>
              <CloseIcon fontSize='inherit' />
            </IconButton>
          </div>
          <Loader className='spinner' type='ThreeDots' color='#333' visible={loading} height={100} width={100} />
          {data && (
            <VariantKitForm
              data={data}
              onClosePanel={onClosePanel}
              onSubmit={values =>
                onSubmit(
                  values.supplyLine,
                  values.variants.map(v => ({ pk: v.pk, quantity: v.quantity })),
                  values.setAsDefault
                )
              }
              isWholesale={isWholesale}
            />
          )}
        </div>
      </SwipeableDrawer>
    </>
  )
}

export default VariantKitPanel
